<template>
  <div class="tabs is-medium">
    <ul>
      <li v-for="tab in tabs" :key="tab.label"
        :class="{'is-active': active(tab)}">
        <router-link v-if="links" :to="tab.link">
          <svgicon v-if="tab.icon" :name="tab.icon" width="25" height="25">
          </svgicon>
          <span v-if="showLabels">{{ tab.label }}</span>
        </router-link>
        <a v-else @click="selected = tab.label">
          <svgicon v-if="tab.icon" :name="tab.icon" width="25" height="25">
          </svgicon>
          <span v-if="showLabels">{{ tab.label }}</span>
        </a>
      </li>
      <slot></slot>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ContentTabBar',
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      },
    },
    showLabels: {
      type: Boolean,
      default: true,
    },
    iconColor: {
      type: String,
      default: '#C4FFF9',
    },
    links: {
      type: Boolean,
      default: true,
    },
    selectedTab: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selected: this.selectedTab,
    };
  },
  watch: {
    selected() {
      this.$emit('update:selectedTab', this.selected);
    },
  },
  computed: {
    ...mapState('route', ['name']),
  },
  methods: {
    active(tab) {
      if (this.links) {
        if (Object.prototype.hasOwnProperty.call(tab, 'activeLinks')) {
          return tab.activeLinks.includes(this.name);
        }
        return tab.link.name === this.name;
      }
      // If not using links
      return this.selected === tab.label;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.tabs {
  margin-bottom: 0;

  ul {
    border-bottom-color: $border-color;

    li.is-active a {
      border-bottom-color: $link-color;
      color: $link-color;
    }

    li {
      a {
        border-bottom-color: $border-color;
        font-size: .9rem;
      }

      a:hover {
        border-bottom-color: $link-color;
        color: $link-color;
      }
    }

    a {
      color: $font-color;
    }

    a:hover {
      color: $link-color;
    }
  }
}
</style>
